import { useState } from "react";
import ConfirmationDialog from "@/components/common/dialogs/ConfirmationDialog";
import {AdminTable, AdminTableProps} from "@/components/common/table";
import { ICohortEntity } from "@buildwitt/shapeshift-types";
import { Box } from "@mui/material";
import { useSSTranslation } from "@/i18n/useSSTranslation";

export interface IProps {
	currentSelected?: number[],
	onClose: (ids?: number[]) => void
}

const headCells: AdminTableProps<"cohort", ICohortEntity>["columns"] = ([
	{
		field: "title",
		flex: 1,
		headerName: "Library",
		type: "string"
	},
	{
		field: "publicLibraryType",
		flex: 1,
		headerName: "Provider",
		type: "string"
	}
]);

const CohortLibraryImportModal: React.FunctionComponent<IProps> = ({
	onClose, 
	currentSelected
}) => {
	const {t} = useSSTranslation();
	const [selected, setSelected] = useState<number[]>(currentSelected ?? []);
	const cohortBaseUrl = "/api/strapi-plugin-shapeshift-lms/cohort";

	const handleClose = () => onClose();
	const handleConfirmation = () => onClose(selected);
	
	return (
		<ConfirmationDialog
			title={t("settings_import_libraries", "Import Libraries")}
			open={true}
			onCancel={handleClose}
			onConfirm={handleConfirmation}
			testIdPrefix="import-cohort-library"
		>
			<Box>
				<AdminTable<"cohort", ICohortEntity>
					url={cohortBaseUrl}
					columns={headCells}
					type="cohort"
					onSelectionModelChange={e => {
						setSelected(e as number[])
					}}
					selectionModel={selected}
					keepNonExistentRowsSelected
					hideExport
					sx={(theme) => ({
						"&.MuiDataGrid-root": {
							backgroundColor: theme.palette.background.paperElevation1
						}
					})}
				/>
			</Box>			
		</ConfirmationDialog>
	);
}

export default CohortLibraryImportModal;